import create from 'zustand'
import { persist } from 'zustand/middleware'

const useSettingsStore = create(persist(
  set => ({
    theme: 'system',
    showSeconds: true,
    dateFormat: 'LLL',
    showConfetti: true,
    useGridLayout: true,

    setTheme: theme => set({ theme }),
    setShowSeconds: showSeconds => set({ showSeconds }),
    setDateFormat: dateFormat => set({ dateFormat }),
    setShowConfetti: showConfetti => set({ showConfetti }),
    setUseGridLayout: useGridLayout => set({ useGridLayout }),

    setSettings: settings => set({ ...settings }),
  }),
  {
    name: 'era-settings',
    version: 0,
  }
))

export default useSettingsStore